import { defineComponent as _defineComponent } from 'vue'
interface Props {
  items?: any[];
  dark?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SocialsList',
  props: {
    items: { default: () => [] },
    dark: { type: Boolean, default: false }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})